import { addressStepAttributes, paymentStepAttributes } from '@cta/donate_call_component/utils/store';
import { computed, reactive } from 'vue';
import { inputToCents } from '@cta/frontend/javascripts/money';

export const store = reactive({
  openStep: 'amount',
  amountStepOpen: computed(() => store.openStep === 'amount'),
  paymentIntervalStepOpen: computed(() => store.openStep === 'payment-interval'),
  addressStepOpen: computed(() => store.openStep === 'address'),
  paymentStepOpen: computed(() => store.openStep === 'payment'),
  errors: {
    amount: undefined,
    firstname: undefined,
    lastname: undefined,
    street: undefined,
    postalcode: undefined,
    region: undefined,
    locality: undefined,
    emailaddress: undefined,
    paymentInterval: undefined,
    paymentType: undefined,
    owner: undefined,
    iban: undefined,
  },
  values: {
    amount: undefined,
    paymentInterval: undefined,
    salutation: undefined,
    firstname: undefined,
    lastname: undefined,
    street: undefined,
    countrycode: undefined,
    postalcode: undefined,
    region: undefined,
    locality: undefined,
    emailaddress: undefined,
    paymentType: undefined,
    owner: undefined,
    iban: undefined,
    rawIban: undefined,
    allowPrefillBankAccount: undefined,
  },
  amountStepValid: computed(() => store.errors.amount === undefined),
  amountErrorUnlocked: false,
  setAmount: (newAmount) => {
    store.values.amount = newAmount;
  },
  paymentIntervalStepValid: computed(() => store.errors.paymentInterval === undefined && !store.paymentIntervalStepConfirmationRequired),
  paymentIntervalErrorUnlocked: false,
  addressStepValid: computed(() => addressStepAttributes.every((name) => store.errors[name] === undefined)),
  addressErrorUnlocked: false,
  addressPrefilled: undefined,
  paymentStepValid: computed(() => paymentStepAttributes.every((name) => store.errors[name] === undefined)),
  paymentErrorUnlocked: false,
  paymentPrefilled: undefined,
});

export default function initializeStore(defaults) {
  store.values.amount = defaults.amountPrefill ? inputToCents(defaults.amountPrefill) : undefined;
  store.values.paymentInterval = defaults.defaultPaymentInterval;
  store.paymentIntervalStepConfirmationRequired = defaults.requirePaymentIntervalConfirmation || !defaults.defaultPaymentInterval;
  store.values.salutation = defaults.prefilledAttributes.salutation || defaults.defaultSalutation;
  store.values.firstname = defaults.prefilledAttributes.firstname;
  store.values.lastname = defaults.prefilledAttributes.lastname;
  store.values.street = defaults.prefilledAttributes.street;
  store.values.locality = defaults.prefilledAttributes.locality;
  store.values.postalcode = defaults.prefilledAttributes.postalcode;
  store.values.region = defaults.prefilledAttributes.region;
  store.values.countrycode = defaults.prefilledAttributes.countrycode || defaults.defaultCountryCode;
  store.values.emailaddress = defaults.prefilledAttributes.emailaddress;
  store.values.paymentType = defaults.paymentTypes.includes(defaults.prefilledAttributes.paymentType)
    ? defaults.prefilledAttributes.paymentType
    : undefined;
  store.values.owner = defaults.prefilledAttributes.owner;
  store.values.iban = defaults.prefilledAttributes.iban;
  store.values.rawIban = defaults.prefilledAttributes.iban;

  store.addressPrefilled = addressStepAttributes.some((name) => defaults.prefilledAttributes[name] !== undefined);
  store.paymentPrefilled = defaults.prefilledAttributes['owner'] !== undefined || defaults.prefilledAttributes['iban'] !== undefined;

  return store;
}
